import React, { useEffect, useState } from "react";
import { IoIosArrowUp } from "react-icons/io";
import "./scrolltotopbutton.scss";

const ScrollToTopButton = () => {
	const [visible, setVisible] = useState(false);
	
	const toggleVisibility = () => {
		if (window.scrollY > 300) {
			setVisible(true);
		} else {
			setVisible(false);
		}
	};
	
	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth"
		});
	};
	
	useEffect(() => {
		window.addEventListener("scroll", toggleVisibility);
		
		return () => window.removeEventListener("scroll", toggleVisibility);
	}, []);
	
	return (
		<>
			{visible && (
				<button className="scrollToTopBtn" onClick={scrollToTop}>
					<IoIosArrowUp />
				</button>
			)}
		</>
	);
};

export default ScrollToTopButton;